import { useEffect } from "react";
import ContactSection from "../components/home/ContactSection";
import Reveal from "../components/Reveal";

export default function ContactoPage() {
  useEffect(() => {
    document.title = "Contacto | Ospino & Piñeres Abogados";
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="pt-36 pb-16 md:pt-44 md:pb-20 bg-white border-b border-slate-100">
        <div className="container-x">
          <Reveal>
            <div className="flex items-center gap-3 mb-5">
              <span className="gold-rule" />
              <span className="overline">Hablemos</span>
            </div>
            <h1 className="font-serif text-navy-900 text-4xl md:text-5xl lg:text-6xl leading-[1.05] max-w-3xl">
              Conversemos sobre tu <em className="italic" style={{ color: "#C5A059" }}>caso</em>.
            </h1>
            <p className="mt-7 text-slate-600 text-base md:text-lg leading-relaxed max-w-2xl">
              Compártenos tu situación. Un asesor revisará tu solicitud y te contactará con la ruta jurídica más adecuada.
            </p>
          </Reveal>
        </div>
      </section>
      <ContactSection />
    </>
  );
}